import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import cn from "@/hooks/class-names";
import { breadCrumPadding } from "@/constants/class.config";
import CustomText from "../text/custom-text";
import PentagonModule from "@/components/animation/pentagon/Index";

export const MenuItems = [
  { languageKey: "home", url: "/" },
  {
    languageKey: "About",
    url: "",
    hasChild: [
      { languageKey: "Overview", url: "/about/overview" },
      { languageKey: "Corporate Profile", url: "/about/corporate-profile" },
      { languageKey: "Our Journey", url: "/about/our-journey" },
      { languageKey: "Mission & Vision", url: "/about/mission-and-vision" },
      {
        languageKey: "Implementation Framework",
        url: "/about/implementation-framework",
      },
      {
        languageKey: "Leadership & Management",
        url: "/about/leadership-and-management",
      },
      { languageKey: "Board of Directors", url: "/about/board-of-directors" },
      {
        languageKey: "Right to Information",
        url: "/about/right-to-information",
      },
      {
        languageKey: "ISO Certification",
        url: "/assets/pdfs/ISO_Certificate-_NICDC.pdf",
        target: "_blank",
      },
      { languageKey: "Links", url: "/about/links" },
    ],
  },
  {
    languageKey: "Projects",
    url: "",
    hasChild: [
      {
        languageKey: "NICDC Corridor Development Programme",
        url: "/projects/national-industrial-corridor-development-programme",
      },
      {
        languageKey: "4 Projects Developed",
        url: "",
        hasChild: [
          {
            languageKey: "Dholera Special Investment Region, Gujarat",
            url: "/projects/4-projects-developed/dholera-special-investment-region-gujarat",
          },
          {
            languageKey: "Aurangabad Industrial City (AURIC), Maharashtra",
            url: "/projects/4-projects-developed/aurangabad-industrial-city-auric-maharashtra",
          },
          {
            languageKey: "Integrated Industrial Township, Greater Noida",
            url: "/projects/4-projects-developed/integrated-industrial-township-greater-noida",
          },
          {
            languageKey: "Integrated Industrial Township, Vikram Udyogpuri",
            url: "/projects/4-projects-developed/integrated-industrial-township-vikram-udyogpuri",
          },
        ],
      },
      {
        languageKey: "4 Projects Nearing Completion",
        url: "",
        hasChild: [
          {
            languageKey: "Tumakuru Industrial Area, Karnataka",
            url: "/projects/4-projects-nearing-completion/tumakuru-industrial-area-karnataka",
          },
          {
            languageKey: "Krishnapatnam Industrial Area, Andhra Pradesh",
            url: "/projects/4-projects-nearing-completion/krishnapatnam-industrial-area-andhra-pradesh",
          },
          {
            languageKey:
              "Integrated Multi Modal Logistics Hub (IMLH), Nangal Chaudhary",
            url: "/projects/4-projects-nearing-completion/integrated-multi-modal-logistics-hub-nangal-chaudhary",
          },
          {
            languageKey:
              "Multi Modal Logistics Hub & Multi Modal Transport Hub, Dadri, Greater Noida, U.P.",
            url: "/projects/4-projects-nearing-completion/multi-modal-logistics-and-transport-hub-dadri-greater-noida-up",
          },
        ],
      },
      {
        languageKey: "12 New Projects",
        url: "",
        hasChild: [
          {
            languageKey: "IMC Khurpia, Uttarakhand",
            url: "/projects/12-new-projects/imc-khurpia-uttarakhand",
          },
          {
            languageKey: "IMC Rajpura Patiala, Punjab",
            url: "/projects/12-new-projects/imc-rajpura-patiala-punjab",
          },
          {
            languageKey: "IMC Hisar, Haryana",
            url: "/projects/12-new-projects/imc-hisar-haryana",
          },
          {
            languageKey: "IMC Agra, Uttar Pradesh",
            url: "/projects/12-new-projects/imc-agra-uttar-pradesh",
          },
          {
            languageKey: "IMC Prayagraj, Uttar Pradesh",
            url: "/projects/12-new-projects/imc-prayagraj-uttar-pradesh",
          },
          {
            languageKey: "IMC Gaya, Bihar",
            url: "/projects/12-new-projects/imc-gaya-bihar",
          },
          {
            languageKey: "IMC Dighi Port Ind. Area, Maharashtra",
            url: "/projects/12-new-projects/dighi-port-ind-area-maharashtra",
          },
          {
            languageKey: "Jodhpur Pali Marwar, Rajasthan",
            url: "/projects/12-new-projects/jodhpur-pali-marwar-rajasthan",
          },
          {
            languageKey: "Kopparthy, Andhra Pradesh",
            url: "/projects/12-new-projects/kopparthy-andhra-pradesh",
          },
          {
            languageKey: "Orvakal, Andhra Pradesh",
            url: "/projects/12-new-projects/orvakal-andhra-pradesh",
          },
          {
            languageKey: "Zaheerabad, Telangana",
            url: "/projects/12-new-projects/zaheerabad-telangana",
          },
          {
            languageKey: "Palakkad, Kerala",
            url: "/projects/12-new-projects/palakkad-kerala",
          },
        ],
      },
    ],
  },
  { languageKey: "Tenders", url: "/tenders" },

  { languageKey: "Investors", url: "/investors" },
  {
    languageKey: "Media",
    url: "",
    hasChild: [
      // { languageKey: "News & Events", url: "/blog/series/news-and-events" },
      // { languageKey: "Articles", url: "/blog/series/articles" },
      {
        languageKey: "News & Events",
        url: "/nicdc-media/news-and-events",
        hasChild: [
          {
            languageKey: "Regional News",
            url: "/nicdc-media/news-and-events/regional-news",
          },
        ],
      },
      { languageKey: "Articles", url: "/nicdc-media/articles" },
      { languageKey: "Video Gallery", url: "/nicdc-media/video-gallery" },
      { languageKey: "Gallery", url: "/nicdc-media/gallery" },
    ],
  },
  {
    languageKey: "Resources",
    url: "",
    hasChild: [
      {
        languageKey: "Corporate Brochure",
        url: "/resources/corporate-brochure",
      },
      {
        languageKey: "Meetings",
        url: "",
        hasChild: [
          {
            languageKey: "Annual General Meeting",
            url: "/resources/meetings/annual-general-meeting",
          },
          {
            languageKey: "Calendar of Meetings",
            url: "/resources/meetings/calendar-of-meeting",
          },
        ],
      },
      { languageKey: "Pitch Book", url: "/resources/pitch-book" },
      {
        languageKey: "Annual Reports",
        url: "",
        hasChild: [
          {
            languageKey: "Reports of NICDC",
            url: "/resources/annual-reports/reports-of-nicdc",
          },
          {
            languageKey: "Reports of NICDIT",
            url: "/resources/annual-reports/reports-of-nicdit",
          },
          {
            languageKey: "Reports of Subsidiary",
            url: "/resources/annual-reports/reports-of-subsidiary",
          },
        ],
      },
      { languageKey: "CSR Policies", url: "/resources/csr-policies" },
      {
        languageKey: "Environmental Clearances",
        url: "",
        hasChild: [
          {
            languageKey: "NICDC",
            url: "/resources/environmental-clearances/nicdc",
          },
        ],
      },
      {
        languageKey: "Employees Handbook",
        url: "/resources/employees-handbook",
      },
      { languageKey: "PoSH Act, 2013", url: "/resources/posh-act" },
      { languageKey: "Land Allotment", url: "/resources/land-allotment" },
    ],
  },
  {
    languageKey: "Careers",
    url: "",
    hasChild: [
      { languageKey: "NICDC Openings", url: "/careers/nicdc-openings" },
      { languageKey: "NLDSL Openings", url: "" },
      { languageKey: "IICC Openings", url: "" },
      { languageKey: "IITGNL Openings", url: "" },
    ],
  },
  { languageKey: "Contact Us", url: "/contact" },
  { languageKey: "RTI Return Information", url: "/rti-return-information" },
  { languageKey: "Public Grievance Open VC link", url: "/open-vc-link" },
  { languageKey: "Cyber Jagrukta Diwas", url: "/cyber-jagrookta-diwas" },
  { languageKey: "FAQ", url: "/faq" },
  // { languageKey: 'NICDC OPENINGS', url: '/nicdc-openings' },
];
const findBreadcrumbTrail = (menuItems, currentPath, trail = []) => {
  for (let item of menuItems) {
    if (item.url === currentPath) {
      return [...trail, { label: item.languageKey, url: item.url }];
    }
    if (item.hasChild) {
      const childTrail = findBreadcrumbTrail(item.hasChild, currentPath, [
        ...trail,
        { label: item.languageKey, url: item.url || "#" },
      ]);
      if (childTrail.length) return childTrail;
    }
  }
  return [];
};

const CustomBreadcrumbs = ({ type, getFromUrl }) => {

  console.log("getFromUrl----->>", getFromUrl);


  const router = useRouter();
  const findMenuItemByLabel = (menuItems, label) => {
    for (let item of menuItems) {
      if (item.languageKey === label) return item;
      if (item.hasChild) {
        const foundChild = findMenuItemByLabel(item.hasChild, label);
        if (foundChild) return foundChild;
      }
    }
    return null;
  };

  let breadcrumbTrail = [
    { label: "Home", url: "/" },
    ...findBreadcrumbTrail(MenuItems, router.pathname),
  ];

  if (getFromUrl) {
    const mainUrl = router?.asPath;
    const removedDashed = mainUrl?.replaceAll("-", " ");
    const splited = removedDashed?.split("/").filter(Boolean); // Split and remove empty parts

    // Generate breadcrumbs dynamically
    breadcrumbTrail = splited.map((part, index) => {
      if (index === 0) {
        return { label: "Home", url: "/" };
      }

      // Look for "News & Events" in menu items for the correct URL
      const menuItem = findMenuItemByLabel(MenuItems, "News & Events");
      const url = menuItem
        ? menuItem.url
        : `/${splited.slice(0, index + 1).join("/")}`;

      return {
        label: index === 1 ? "News & Events" : decodeURIComponent(part), // Add custom label for the second part
        url,
      };
    });
  }

  const activePage = breadcrumbTrail[breadcrumbTrail.length - 1]?.label || "";

  return (
    <div
      className={cn(
        breadCrumPadding,
        (type && "bg-primary") || "bg-black text-white",
        "!py-6" // Reduced padding from default to py-3
      )}
    >
      <div className="mil-animation-frame">
        <div
          className="mil-animation mil-position-1 mil-scale"
          data-value-1="7"
          data-value-2="1.6"
        >
          <PentagonModule />
        </div>
      </div>
      <div className={cn("mb-4 grid grid-cols-1")}> {/* Reduced margin from mb-4 to mb-2 */}
        <CustomText
          text={activePage}
          className={"laptop:text-[20px] laptop-large:text-[20px] capitalize"} // Reduced font sizes
        />
      </div>
      <div>
        <nav
          className={cn(
            "flex items-center space-x-1 laptop:space-x-2 text-sm text-gray-700 capitalize flex-wrap laptop:flex-nowrap"
          )}
        >
          {breadcrumbTrail.map((item, index) => {
            const isActive = index === breadcrumbTrail.length - 1;
            return (
              <React.Fragment key={index}>
                {isActive ? (
                  <span className="font-bold">{item.label}</span>
                ) : (
                  <Link href={item.url} passHref legacyBehavior>
                    <a className="hover:underline">{item.label}</a>
                  </Link>
                )}
                {index < breadcrumbTrail.length - 1 && <span>/</span>}
              </React.Fragment>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default CustomBreadcrumbs;